import React from 'react';
import { GIFormControl, GICheckbox, GIFormLabel } from '@components/common/app-components/GIInput';
import { FormattedMessage } from 'react-intl';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import Tooltip from '@components/common/tooltip/Tooltip';
import EligibleMembersHeader from './EligibleMembersHeader';
import HardshipExemptionEligibilityTable from './HardshipExemptionEligibilityTable';
import type { IHardshipExemptionFormProps } from './types/apiResponse';
import {
    defaultHardshipTableVisibility,
    householdMembersTooltipEnablesStates,
    showQualifyhardshipQTooltip,
    seekingCoverageEnabledStates,
    tobaccoUseCheckRequiredStates,
    seekingCoverageTooltipEnablesStates,
    showEligibleMembersHeaderStates
} from './utils/app.constants';

const HardshipExemptionForm: React.FC<IHardshipExemptionFormProps> = ({
    additionalInfo,
    isHardExemptionChecked,
    isHardshipExemptCheckBoxVisible,
    onHandleExemptionNumberChange,
    onHandleHardExemptionChange,
    onHandleTobaccoUseChange,
    onHandleHasDisabilityChange,
    stateCode,
    eligibilityDetails,
}) => {
    const onHandleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked;
        onHandleHardExemptionChange(isChecked);
    };
    const shouldShowEligibleMembersHeader = showEligibleMembersHeaderStates.includes(stateCode);
    const shouldShowSeekingCoverage = seekingCoverageEnabledStates.includes(stateCode);
    const shouldShowSeekingCoverageTooltip = seekingCoverageTooltipEnablesStates.includes(stateCode);
    const shouldShowHouseholdMembers = householdMembersTooltipEnablesStates.includes(stateCode);
    const shouldShowTobaccoUseCheckRequired = tobaccoUseCheckRequiredStates.includes(stateCode);
    return (
        <>
            <ConditionalRendering isTrue={isHardshipExemptCheckBoxVisible}>
                <fieldset className="usa-fieldset">
                    <div className="usa-checkbox">
                        <GIFormControl id="hardExemptionWrapper" name="hardExemption" type="checkbox">
                            <GICheckbox
                                id="hardExemption"
                                checked={isHardExemptionChecked}
                                onChange={onHandleCheckboxChange}
                                name="hardExemption"
                            />
                            <GIFormLabel id="hardExemptionLabel">
                                <FormattedMessage id="indportal.tobacco.qualifyHardshipQ" />
                                <ConditionalRendering isTrue={showQualifyhardshipQTooltip.includes(stateCode)}>
                                    <Tooltip
                                        id="QualifyhardshipQTooltip"
                                        index="qualify-hardship-QTooltip"
                                        content="indportal.tobacco.qualifyHardshipQPopup"
                                        icon="question-circle"
                                        multiline={true}
                                        triggerDecorationClassName="border-none"
                                    />
                                </ConditionalRendering>
                            </GIFormLabel>
                        </GIFormControl>
                    </div>
                </fieldset>
            </ConditionalRendering>
            <ConditionalRendering isTrue={isHardExemptionChecked || defaultHardshipTableVisibility.includes(stateCode)}>
                <ConditionalRendering isTrue={shouldShowEligibleMembersHeader}>
                    <EligibleMembersHeader />
                </ConditionalRendering>
                <ConditionalRendering isTrue={eligibilityDetails && eligibilityDetails.length > 0}>
                    <HardshipExemptionEligibilityTable
                        data={eligibilityDetails}
                        additionalInfo={additionalInfo}
                        onHandleTobaccoUseChange={onHandleTobaccoUseChange}
                        onHandleHasDisabilityChange={onHandleHasDisabilityChange}
                        onHandleExemptionNumberChange={onHandleExemptionNumberChange}
                        isHardExemptionChecked={isHardExemptionChecked}
                        showSeekingCoverage={shouldShowSeekingCoverage}
                        shouldShowSeekingCoverageTooltip={shouldShowSeekingCoverageTooltip}
                        shouldShowHouseholdMembers={shouldShowHouseholdMembers}
                        shouldShowTobaccoUseCheckRequired={shouldShowTobaccoUseCheckRequired}
                    />
                </ConditionalRendering>
            </ConditionalRendering>
        </>
    );
};

export default HardshipExemptionForm;
